import { Form, Button, FormInstance, Flex } from 'antd';
import { useTranslation } from 'react-i18next';

import { Row, FormItemHalf, MobileFormItemFull } from './TagsWithCourses.styles';

import { CourseWithSectionsSelector, TagSelector } from '@/components/Form';
import { Icon } from '@/components/Icon';
import { useIsMobile } from '@/hooks';

type Props = {
  form: FormInstance;
};

export const TagsWithCourses: React.FC<Props> = ({ form }) => {
  const { t } = useTranslation('CommonEventsTranslations');
  const tagsWithCourses = Form.useWatch('tagsWithCourses', form);
  const isMobile = useIsMobile('xs');

  return (
    <Form.List name="tagsWithCourses" initialValue={[{}]}>
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }) => (
            <Flex
              key={key}
              gap={16}
              vertical={isMobile}
              align={!isMobile ? 'start' : undefined}
              style={{ width: '100%' }}>
              <Row>
                <FormItemHalf
                  {...restField}
                  name={[name, 'tag']}
                  label={t('FORMATION', { number: name + 1 })}
                  rules={[{ required: true, message: t('CAN_NOT_CREATE_EVENT_WITHOUT_TAG') }]}
                  validateTrigger={['change', 'blur']}>
                  <TagSelector allowClear maxTagCount="responsive" />
                </FormItemHalf>
                {!isMobile && (
                  <FormItemHalf
                    {...restField}
                    name={[name, 'coursesWithSections']}
                    label={t('COURSE_AND_SECTION')}>
                    <CourseWithSectionsSelector tag={tagsWithCourses?.[name]?.tag} />
                  </FormItemHalf>
                )}
                {!isMobile && (
                  <Button type="link" icon={<Icon i="TrashCan" />} onClick={() => remove(name)} />
                )}
              </Row>
              {isMobile && (
                <>
                  <MobileFormItemFull
                    {...restField}
                    name={[name, 'coursesWithSections']}
                    label={t('COURSE_AND_SECTION')}>
                    <CourseWithSectionsSelector tag={tagsWithCourses?.[name]?.tag} />
                  </MobileFormItemFull>
                  <Button type="link" icon={<Icon i="TrashCan" />} onClick={() => remove(name)} />
                </>
              )}
            </Flex>
          ))}
          <Form.Item>
            <Button type="link" onClick={() => add()} icon={<Icon i="Add" />}>
              {t('ADD_FORMATION')}
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
};
